/**
 * @author      grady@zumper.com (Grady Kuhnline)
 * @copyright   Copyright (c) 2018, Zumper
 * @description MessageFormLoadable
 */

/** @jsx jsx */
import { jsx } from '@emotion/react'
import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import React from 'react'

import { logger } from '../../../logger'
import * as css from './MessageFormLoadingFallback.styles'

const onLoadingError = (error: unknown) => {
  logger.error('loading error for MessageFormLoadable', error)
}

const loadFn = /* #__LOADABLE__ */ async () => {
  return await import(/* webpackChunkName: "MessageForm" */ './MessageFormContainer')
}

const handleReload = async () => {
  try {
    await MessageFormLoadable.reload()
  } catch (error) {
    logger.info('Failed to reload MessageFormLoadable', error)
  }
}

const message = "Sorry, we couldn't load the message form..."

const options = {
  errorFallback: () => (
    <ErrorFallback css={css.messageForm} message={message} onClickReload={handleReload} />
  ),
  loadingFallback: () => <LoadingFallback css={css.messageForm} name="message form" />,
  onLoadingError,
}

export const MessageFormLoadable = createLazyLoadableSection(loadFn, options)
